import { render, staticRenderFns } from "./AcademyManagement.vue?vue&type=template&id=6441bcca&lang=pug"
import script from "./AcademyManagement.vue?vue&type=script&lang=ts"
export * from "./AcademyManagement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports